import DiseaseCodeMerge from './DiseaseCodeMerge';
export default DiseaseCodeMerge;